import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { HashRouter, Redirect } from 'react-router-dom'
import { currentWidget, popupOpenClose, setDoorKeyNotificaionPage, setLoadingMass, setQRScannerPage, setRegPage, setShowCustomPopup, validateDigitalKey, validateReservationNo } from '../../action/action'
import { sendAnalytics, setDoorKeyGuide } from '../../action/homeAction'
import { bluetoothCheckMsg, CLICKED, DEMO, DONT_FORCE_TO_ENABLE_BLUETOOTH_WHILE_DOORKEY_BUT_JUST_WARN, DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN, EXIT, globalIV, globalSalt, internetCheckMsg, QRSCANENABLE, VERIFY_THROUGH_CMS } from '../../config/constant'
import { AesUtil } from '../../JS/AesUtil'
import { setGoHome, setLoader, setLoaderClosed, setPermissionWhileDoorKeyInfo } from '../../layout2.0/action/homeAction'
import { setSuccessFailPop } from '../../layout2.0/action/viewBillAction2'
import runRequestPermission from '../../layout2.0/JS/runRequestPermission'
import { booleanConditionCheck, getDefaultAnalyticsLabel, toBool } from '../../layout2.0/JS/utility'
import OtpValidation from './otpValidation'
import SelectAuthOption from './SelectAuthOption'
import { checkIsBluetoothEnabledForDoorKey } from './helper'
import { withTranslation } from 'react-i18next'

let noOfAttemptsValidateGuest = 0;
let noOfAttemptsQRScan = 0;

function ValidationOptions(props) {

    const [showRoomDoor, setShowRoomDoor] = useState(false)
    const [apiCalled, setApiCalled] = useState(false)
    const [validateKeyResponse, setValidateKeyResponse] = useState(false)
    const [token, setToken] = useState(localStorage.getItem("GuestJourneySessionToken"))
    const [showAuthOptions, setShowAuthOptions] = useState(false)
    const [showOtpInputScreen, setShowOtpInputScreen] = useState(false)

    let validateKeyCancelToken = axios.CancelToken
    let cancelValidateKeySource = validateKeyCancelToken.source();
    let loaderTimer = null;
    let apiTimer = null;

    const isValidationDone = localStorage.getItem("VerifiedUser") == "true" || (props.digitalKeySupportedAuthMethods.length === 0) || props.skipDigitalKeyValidation;
    const otpEnabled = props.digitalKeySupportedAuthMethods.includes("OTP")
    const qrOnTVEnabled = props.digitalKeySupportedAuthMethods.includes("QRonTV")
    const fdEnabled = props.digitalKeySupportedAuthMethods.includes("FrontdeskAPI")
    const qrSharingEnabled = props.digitalKeySupportedAuthMethods.includes("QRshare")

    
    const sendGAEvent = (action, message, callback, extraLabelInfo) => {
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        
        props.sendAnalytics(
            props.guestDetail, 
            "Digital Door Key", 
            action, 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("doorKeySessionToken"), "errorMessage": message && message, ...extraLabelInfo},
            0, 
            props.guestIsLoggedIn,
            callback && callback
        );
    }

    const callGuestValidationAPIs = () => {


        const loggedInGuestDetails = localStorage.getItem("Set_Current_Logged_In_Guest_Details") && JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));
        setApiCalled(true)
        try{
            console.log('inside cms verification block')
            if(!(localStorage.getItem("VerifiedUser") == 'true')){
                console.log('user not verified flow')
                props.validateDigitalKey(token, loggedInGuestDetails[0], loggedInGuestDetails[0].reservationNumber, "keyRequest", validateDigitalKeyCallback, cancelValidateKeySource)
                props.setLoader(true, "Verifying guest", true )
            } else {
                console.log('user verified flow')
                props.validateDigitalKey(token, loggedInGuestDetails[0], loggedInGuestDetails[0].reservationNumber, "validateStatus", validateDigitalKeyCallback, cancelValidateKeySource)
                props.setLoader(true, "Verifying guest", true )
            }
            startTimer()
        } catch (err) {
            props.setLoader(false, null, false)
            console.log("error in calling validation api", err)
            sendGAEvent("FRONT DESK VERIFICATION - FAILED", `Source: KeyClick > Frontdesk Flow > callValidationAPIS, Error: error while tring to call digitalKey api: ${err.message}`, () => {}, {"noOfAttempts": noOfAttemptsValidateGuest + 1, "pageName": "FRONT DESK VERIFICATION", displayError: props.t("doorKey_event_error_messages.APP_FDK_CALL_VALIDATE_API_FAIL"), errorCode: 'APP_FDK_CALL_VALIDATE_API_FAIL'})
            noOfAttemptsValidateGuest = noOfAttemptsValidateGuest + 1
            // props.setGoHome(true);
            if(!props.loaderClosed) props.setSuccessFailPop(true, false, "Something went wrong. Please try again.")
            if(props.digitalKeySupportedAuthMethods.length == 1) {
                props.setGoHome(true)
                sendGAEvent(EXIT, "", ()=>{}, {"pageName": "FRONT DESK VERIFICATION"});
            }
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("error while tring to call digitalKey api: " + err.message)
            }
        }
    }

    const validateDigitalKeyCallback = (status, message) => {
        console.log('Response for digikey api status:', status)
        setValidateKeyResponse(true)
        setApiCalled(true)

        clearTimeout(loaderTimer)
        clearTimeout(apiTimer)

        if(status == undefined) return
        if(booleanConditionCheck(status)) {
            console.log('successfully verified user')
            if(!props.loaderClosed) props.setDoorKeyNotificaionPage(true);
            localStorage.setItem("FdFlow", true)
            localStorage.setItem('VerifiedUser', true)
            props.setLoader(false, null, false )
            const dk_front_desk_verification_success_event_sent = localStorage.getItem("dk_front_desk_verification_success_event_sent") == "true"
            if(!dk_front_desk_verification_success_event_sent)
                sendGAEvent("FRONT DESK VERIFICATION - SUCCESS", "", () => localStorage.setItem("dk_front_desk_verification_success_event_sent",true), {"pageName": "FRONT DESK VERIFICATION"})
        } else {
            if(message == "Something went wrong. Please try again."){
                if(window.FireBasePlugin){
                    window.FirebasePlugin.logError("Digital key api gets timeout")
                }
                if(!props.loaderClosed) props.setSuccessFailPop(true, false, "Something went wrong. Please try again.")
            } else {
                localStorage.setItem('VerifiedUser', false)
                if(!props.loaderClosed) {
                    props.popupOpenClose(true, message)
                    props.setGoHome(true);
                }
            }
            props.setLoader(false, null, false )
            sendGAEvent("FRONT DESK VERIFICATION - FAILED", "Source: FrontDesk Flow > validateDigitalKeyCallback:" + message, () => {}, {"noOfAttempts": noOfAttemptsValidateGuest + 1, "pageName": "FRONT DESK VERIFICATION", issueKeyFlag: status, displayError: props.t("doorKey_event_error_messages.APP_FDK_VALIDATE_API_FAIL"), errorCode: 'APP_FDK_VALIDATE_API_FAIL' })
            noOfAttemptsValidateGuest = noOfAttemptsValidateGuest + 1
            if(props.digitalKeySupportedAuthMethods.length == 1) {
                props.setGoHome(true)
                sendGAEvent(EXIT, "", ()=>{}, {"pageName": "FRONT DESK VERIFICATION"});
            }
        }
    }


    const startTimer = () => {
        apiTimer = setTimeout(() => {
            cancelValidateKeySource.cancel()
            validateKeyCancelToken = axios.CancelToken
            cancelValidateKeySource = validateKeyCancelToken.source();
            if(!validateKeyResponse){
                validateDigitalKeyCallback(false, "Server timeout. Please try again.")
            }
        }, 60000)

        // Shifted below logic to the loader component
        // loaderTimer = setTimeout(() => {
        //     if(!validateKeyResponse){
        //         props.setLoader(true, "Verifying guest", true)
        //     }
        // },7000)
    }

    const onError = (feature) => {
        if(feature == "BLUETOOTH"){
            // props.popupOpenClose(true, bluetoothCheckMsg);
            props.setShowCustomPopup(true, {
                htmlTagId: "bluetooth-required",
                title: "Bluetooth Required",
                heading: bluetoothCheckMsg,
                primaryButtonText: "Continue",
                closeOnClick: () => {
                    props.setGoHome(true);
                    props.setShowCustomPopup(false, {})
                },
                primaryOnClick: () => {
                    checkAuthType()
                    props.setShowCustomPopup(false, {})
                },
            })
            return
        } else {
            sendGAEvent("DOOR KEY VALIDATION - FAILED - ISSUE UNKNOWN", "Something went wrong.", () => {}, {"pageName": "NATIVE PERMISSIONS", displayError: props.t("doorKey_event_error_messages.SDK_DOOR_KEY_VALIDATION_UNKNOWN_FAIL"), errorCode: 'SDK_DOOR_KEY_VALIDATION_UNKNOWN_FAIL'})
            props.popupOpenClose(true, "Something went wrong.");
        }
        sendGAEvent(EXIT, "", () => {}, {"pageName": "NATIVE PERMISSIONS"});
        console.log("network issue.")
        props.setGoHome(true);
    }

    const startScanner = () => {
        try {
            const dk_qr_verification_success_event_sent = localStorage.getItem("dk_qr_verification_success_event_sent") == "true"
            if(!dk_qr_verification_success_event_sent) sendGAEvent("QR SCANNER", "", () => {}, {"pageName": "QR SCANNER"})
            window.QRScanner.scan(displayContents);
            // Make the webview transparent so the video preview is visible behind it.
            window.QRScanner.show((status) => {
                console.log("status in show method", status);
            });
            // Be sure to make any opaque HTML elements transparent here to avoid
            // covering the video.
        } catch (err) {
            console.log("error in QRScanner", err)
        }
    }

    const stopScanner = () => {
        window.QRScanner.destroy(status => console.log('destroyed scanner status', status))
    }

    const displayContents = (err, text) => {
        if (err) {
            // an error occurred, or the scan was canceled (error code `6`)
            // alert("error in scanning->" + err);
            console.log("we got err while scanning", err)
            sendGAEvent("QR SCANNER - FAILED", "Got err while scanning" + err, () => {}, {"pageName": "QR SCANNER", "noOfAttempts": noOfAttemptsQRScan + 1, displayError: props.t("doorKey_event_error_messages.APP_QR_SCANNER_FAILED"), errorCode: 'APP_QR_SCANNER_FAILED'})
            noOfAttemptsQRScan = noOfAttemptsQRScan + 1
            stopScanner()
            // props.setGoHome(true);
        } else {
            // The scan completed, display the contents of the QR code:
            console.log("we are in scan success");
            // props.setQRScannerPage(false);
            processScanText(text)
        }
        window.QRScanner.hide(function (status) {
            console.log(status);
            // alert(status + "-----" + props.QRScanPage)
        });
    }

    const processScanText = (text) => {
        let reservationNo, token, indexDelimiter;
        let aesUtil = new AesUtil(128, 1000);

        if (text && text.indexOf("token=")) {
            indexDelimiter = text.indexOf("token=")
            console.log("QR logs indexDelimiter", indexDelimiter)
            token = text.slice(indexDelimiter + 6, text.length);
            let plaintext = aesUtil.decrypt(
                globalSalt,
                globalIV,
                "1234567891234567",
                token
            )
            
            if (plaintext) {
                indexDelimiter = plaintext.indexOf("&")
                reservationNo = plaintext.slice(0, indexDelimiter);
                console.log("QR logs  reservationNo", reservationNo)
                console.log("QR logs  locationId : props.guestDetail.locationId", locationId, props.guestDetail.locationId)

                let SessionToken = localStorage.getItem("GuestJourneySessionToken");
                let locationId = locationId ? locationId : props.guestDetail.locationId
                
                if (reservationNo && locationId){
                    props.setLoadingMass(true);

                    props.validateReservationNo(SessionToken, reservationNo, locationId, reservCallBack);
                }
                else{
                    console.log("issue with location or reservation")
                    // props.setErrorPopDoorKey(true);
                    props.popupOpenClose(true, "Unable to retrieve your details. Please contact Front Desk for assistance.")
                    props.setQRScannerPage(false);
                    sendGAEvent("QR SCANNER - FAILED", "Error: Fails to retrieve reservation number and location id, Error Message: Unable to retrieve your details. Please contact Front Desk for assistance.", () => {}, { "pageName": "QR SCANNER", "noOfAttempts" : noOfAttemptsQRScan + 1, displayError: props.t("doorKey_event_error_messages.APP_QR_SCANNER_DATA_PARSE_FAILED"), errorCode: 'APP_QR_SCANNER_DATA_PARSE_FAILED'})
                    noOfAttemptsQRScan = noOfAttemptsQRScan + 1
                    sendGAEvent(EXIT, "", ()=>{}, {"pageName": "QR SCANNER"});
                    stopScanner()
                    // props.setGoHome(true);
                }

            } else {
                props.popupOpenClose(true, "Invalid QR code. Please scan again.")
                sendGAEvent("QR SCANNER - FAILED", "Error: Fails to retrieve texts form QR, Error Message: Invalid QR code. Please scan again.", () => {}, { "pageName": "QR SCANNER", "noOfAttempts" : noOfAttemptsQRScan + 1, displayError: props.t("doorKey_event_error_messages.APP_QR_SCANNER_INVALID_QR"), errorCode: 'APP_QR_SCANNER_INVALID_QR'})
                noOfAttemptsQRScan = noOfAttemptsQRScan + 1
                // props.setErrorPopDoorKey(true);
                props.setQRScannerPage(false);
                sendGAEvent(EXIT, "", () => {}, {"pageName": "QR SCANNER"});
                stopScanner()
                // props.setGoHome(true);
                //props.setDoorKeyNotificaionPage(false);
            }
            //props.setDoorKeyValidationPopUp(false);
            props.setLoadingMass(false);
        } else {
            props.popupOpenClose(true, "Invalid QR code. Please scan again.")
            // props.setErrorPopDoorKey(true);
            sendGAEvent("QR SCANNER - FAILED", "Error: QR texts doesn't contain the token, Error Message: Invalid QR code. Please scan again.", () => {}, {"pageName": "QR SCANNER", "noOfAttempts" : noOfAttemptsQRScan + 1, displayError: props.t("doorKey_event_error_messages.APP_QR_SCANNER_INVALID_QR"), errorCode: 'APP_QR_SCANNER_INVALID_QR'})
            noOfAttemptsQRScan = noOfAttemptsQRScan + 1
            props.setQRScannerPage(false);
            sendGAEvent(EXIT, "", ()=>{}, {"pageName": "QR SCANNER"});
            stopScanner()
            // props.setGoHome(true);
            //props.setDoorKeyNotificaionPage(false);
        }
    }

    const reservCallBack = (status) => {
        console.log("QR logs reservCallBack", status);
        props.setLoadingMass(false);
        // props.setRegPage(false);
        //localStorage.setItem("ConnectorIP", defultIP);
        
        if (status) {
            // props.SetCallNativeMethods(true);
            // props.setDoorKeyValidationPopUp(false);
            localStorage.setItem('VerifiedUser', true)
            props.setDoorKeyNotificaionPage(true);
            props.setQRScannerPage(false);
            stopScanner()
            sendGAEvent("QR SCANNER - SUCCESS", "", () => {}, {"pageName": "QR SCANNER"})
           
        } else {
            props.popupOpenClose(true, "Unable to validate your details. Please contact Front Desk for assistance.")
            sendGAEvent("QR SCANNER - FAILED", "Unable to validate your details. Please contact Front Desk for assistance", () => {}, { "pageName": "QR SCANNER", "noOfAttempts" : noOfAttemptsQRScan + 1, displayError: props.t("doorKey_event_error_messages.APP_QR_SCANNER_VALIDATION_FAILED"), errorCode: 'APP_QR_SCANNER_VALIDATION_FAILED'})
            noOfAttemptsQRScan = noOfAttemptsQRScan + 1
            // props.setErrorPopDoorKey(true);
            props.setQRScannerPage(false);
            sendGAEvent(EXIT, "", () => {}, {"pageName": "QR SCANNER"});
            stopScanner()
        }
    }

    const qrFlow = () => {
        let VerifiedUser = localStorage.getItem('VerifiedUser') == "true"
        if(!VerifiedUser){
            // window.android.checkPermissions();
            if(window.cordova){
                props.setQRScannerPage(true);
                startScanner();
                // if(window.android) runRequestPermission('CAMERA', permissionCallback)
                // else if(window.cordova.plugins && window.cordova.plugins.AssaAbloy) permissionCallback(true)
            } else {
                console.log("Can't open qr scanner on browser")
            }
        } else {
            props.setDoorKeyNotificaionPage(true);
        }
    }

    const fdFlow = () => {
        try {
            const dk_front_desk_verification_event_sent = localStorage.getItem("dk_front_desk_verification_event_sent") == "true"
            if(!dk_front_desk_verification_event_sent) sendGAEvent("FRONT DESK VERIFICATION", "", () => {localStorage.setItem("dk_front_desk_verification_event_sent", true)}, {"pageName": "FRONT DESK VERIFICATION"})
            setValidateKeyResponse(false)
            props.setLoaderClosed(false)
            callGuestValidationAPIs()
        } catch (e) {
            sendGAEvent("FRONT DESK VERIFICATION - FAILED", "Source: validationOptions > Frontdesk Flow : Error: error while tring to call digitalKey api:" + e.message, () => {}, {"noOfAttempts": noOfAttemptsValidateGuest + 1, "pageName": "FRONT DESK VERIFICATION", displayError: props.t("doorKey_event_error_messages.APP_FDK_VALIDATE_API_FAIL"), errorCode: 'APP_FDK_VALIDATE_API_FAIL'})
            noOfAttemptsValidateGuest = noOfAttemptsValidateGuest + 1
            // props.setGoHome(true);
        }
    }

    const otpFlow = () => {
        // call otp api and show in ui that otp is sent please enter here
        setShowAuthOptions(false)
        setShowOtpInputScreen(true)
    }

    const checkAuthType = () => {
        if(isValidationDone){
            localStorage.setItem("VerifiedUser", true)
            setShowRoomDoor(true)
            return
        }
        setShowAuthOptions(true)
        return;
    }

    const handleOptionClick = option => {
        switch(option){
            case "QRonTV": qrFlow();
                break;
            case "FrontdeskAPI": fdFlow();
                break;
            case "OTP": otpFlow();
                break;
            default: fdFlow();
        }
    }

    const customHandlingIsPermissionEnabledForDoorKey = (isEnabled, permissionType) =>{

        const permissionDetails={
            BLUETOOTH:{
                errorMessage: bluetoothCheckMsg,
                warnCountVariableNameInStore: "bluetoothWarnCount"
            }
        }

        if(isEnabled){
            sendGAEvent(`${permissionType} CHECK - SUCCESS`, "", () => {}, {"pageName": "NATIVE PERMISSIONS"});
            return true
        } else{
            if(DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN && props.permissionWhileDoorKeyInfo[permissionDetails[permissionType]["warnCountVariableNameInStore"]] >= 1){
                sendGAEvent(`${permissionType} CHECK - FAILED - BUT MAKING IT EXCEPTIONALLY PASS IN APP`, permissionDetails[permissionType]["errorMessage"] , () => {}, {"pageName": "NATIVE PERMISSIONS", displayError: `${permissionType} UNAVAILABLE: ${props.t("doorKey_event_error_messages.APP_FEATURE_UNAVAILABLE")}`, errorCode: `APP_${permissionType.toUpperCase()}_UNAVAILABLE`});
                return true;
            } else {
                sendGAEvent(`${permissionType} CHECK - FAILED`, permissionDetails[permissionType]["errorMessage"], () => {}, {"pageName": "NATIVE PERMISSIONS", displayError: `${permissionType} UNAVAILABLE: ${props.t("doorKey_event_error_messages.APP_FEATURE_UNAVAILABLE")}`, errorCode: `APP_${permissionType.toUpperCase()}_UNAVAILABLE`});
                props.setPermissionWhileDoorKeyInfo({ [permissionDetails[permissionType]["warnCountVariableNameInStore"]] : props.permissionWhileDoorKeyInfo[permissionDetails[permissionType]["warnCountVariableNameInStore"]] + 1})
                onError(permissionType)
                return false
            }
        }
    }

    useEffect(() => {
        props.currentWidget({widgetType: true});
        let door_key_type = localStorage.getItem("door_key_type");

        if(window.device){

            const isBluetoothEnabled = checkIsBluetoothEnabledForDoorKey(door_key_type, window.device.platform);
            console.log("isBluetoothEnabled", isBluetoothEnabled)
            const isBluetoothEnabledCustomCheck = customHandlingIsPermissionEnabledForDoorKey(isBluetoothEnabled, "BLUETOOTH");

            if (isBluetoothEnabledCustomCheck) {
                checkAuthType()
            } 
        } else {
            checkAuthType()
        }

        return () => {
			noOfAttemptsQRScan = 0;
            noOfAttemptsValidateGuest = 0
            props.currentWidget({});
		}
    }, [])
    




  return (
    <>
        {showRoomDoor && <HashRouter>
                        <Redirect exact to ={ DEMO ? "/doorKey/demoRoomDoorKey" : "/doorKey/roomDoorKey"}/>
        </HashRouter>}
        {showAuthOptions && <SelectAuthOption goBack={() => {props.setGoHome(true);sendGAEvent("EXIT","", () =>{}, {"pageName": "AUTH OPTIONS"})}} onOptionClick={handleOptionClick} supportedMethods={props.digitalKeySupportedAuthMethods} otpEnabled={otpEnabled} qrOnTVEnabled={qrOnTVEnabled} fdEnabled={fdEnabled} qrSharingEnabled={false} />}
        {showOtpInputScreen && <OtpValidation goBack={() => {
            if(props.digitalKeySupportedAuthMethods.length > 1){
                setShowOtpInputScreen(false);
                setShowAuthOptions(true)
            } else {
                props.setGoHome(true)
            }
        }} 
        proceedNext={() => setShowRoomDoor(true)} />}
    </>
  )
}

const mapStateToProps = state => {
    return {
        QRScanPage: state.store.QRScannerPage,
        showPlaceOrder: state.store2.showPlaceOrder,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        CheckedInGuest: state.store.CheckedInGuest,
        DigitalKeyRequestVerified: state.store2.DigitalKeyRequestVerified,
        installedAppName: state.store.installedAppName,
        loaderClosed: state.store2.loaderClosed,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        loginGuestDetails: state.store2.loginGuestDetails,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        digitalKeySupportedAuthMethods: state.store2.digitalKeySupportedAuthMethods,
        permissionWhileDoorKeyInfo: state.store2.permissionWhileDoorKeyInfo,
        skipDigitalKeyValidation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.skipDigitalKeyValidation ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.skipDigitalKeyValidation) : false,
        
    }
}

export default connect(mapStateToProps, {
    popupOpenClose, setDoorKeyNotificaionPage, setLoadingMass, setQRScannerPage, setRegPage, validateDigitalKey, validateReservationNo,
    sendAnalytics, setDoorKeyGuide, currentWidget,
    setLoader, setLoaderClosed, setSuccessFailPop, setGoHome, setPermissionWhileDoorKeyInfo, setShowCustomPopup
})(withTranslation('translations')(ValidationOptions))